import './polyfills.js'; // polyfills first
import React from 'react';
import ReactDOM from 'react-dom/client';
// import 'bootstrap/dist/css/bootstrap.css';
import App from './App';
// import reportWebVitals from './reportWebVitals';
import { v4 as uuidv4 } from 'uuid';
import TagManager from './TagManager';

const nonce = uuidv4();

const tagManagerArgs = {
  gtmId: 'GTM-576TLMSG',
  nonce: nonce,
};

TagManager.initialize(tagManagerArgs);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
